import { createContext, useContext, useEffect } from 'react';

var noop = function noop() {};

export var SkipLinksContext = /*#__PURE__*/createContext({
  skipLinksData: [],
  registerSkipLink: noop,
  unregisterSkipLink: noop
});
export var useSkipLinks = function useSkipLinks() {
  return useContext(SkipLinksContext);
};
export var useSkipLink = function useSkipLink(id, skipLinkTitle) {
  var _useSkipLinks = useSkipLinks(),
      registerSkipLink = _useSkipLinks.registerSkipLink,
      unregisterSkipLink = _useSkipLinks.unregisterSkipLink;

  useEffect(function () {
    if (id && skipLinkTitle) {
      registerSkipLink({
        id: id,
        skipLinkTitle: skipLinkTitle
      });
    }

    return function () {
      unregisterSkipLink(id);
    };
  }, [id, skipLinkTitle, registerSkipLink, unregisterSkipLink]);
};